import { render, staticRenderFns } from "./DialogCreateGroup.vue?vue&type=template&id=2886dfc4"
import script from "./DialogCreateGroup.vue?vue&type=script&lang=js"
export * from "./DialogCreateGroup.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateGroup.vue?vue&type=style&index=0&id=2886dfc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports